export const isInternalContent = item => 'visibility' in item && item.visibility === 'CREATOR_PORTAL_ONLY';